import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { GenesisUnitOfWork } from '../../core/core.module';
import _ from 'lodash';
import { OrderLineDetail } from 'app/core/model/order-line-detail';
import { Order } from 'app/core/model/order';
import { Dealer } from 'app/core/model/dealer';
import { ShipAddress } from 'app/core/model/ship-address';
import { DealerDetailComponent } from 'app/dealers/dealer-detail/dealer-detail.component';
import { OrderService } from 'app/core/data/order.service';

@Component({
    selector: 'app-order-ship-address-address-dialog',
    templateUrl: './order-ship-address-dialog.component.html',
    styleUrls: ['./order-ship-address-dialog.component.scss'],
    standalone: false
})
export class OrderShipAddressDialogComponent implements OnInit {
    result: Subject<any> = new Subject<{ success: boolean; value?: Order }>();
    order: Order;
    states: string[];
    countries: string[] = ['US', 'OTHER'];
    selectedCountry: string = 'US';
    addresses: ShipAddress[];
    selectedAddress: ShipAddress;

    constructor(private uow: GenesisUnitOfWork, public modalRef: BsModalRef, private modalService: BsModalService, private orderService: OrderService) {}

    async ngOnInit() {
        this.states = this.uow.lookups.states;
        this.setSelectedShipCountry();
        await this.getData();
    }

    async getData() {
        this.addresses = await this.uow.getShipAddresses(this.order.dealerId);
    }

    selectedCountryChanged = (e) => {
        this.order.shipToCountry = e.value;
    };

    setSelectedShipCountry() {
        this.selectedCountry = !this.order.shipToCountry || this.order.shipToCountry === 'US' ? 'US' : 'OTHER';
    }

    selectedAddressChanged = (e) => {
        const address = e.value as ShipAddress;
        if (!address) return;

        this.order.shipToLocation = address.location;
        this.order.shipToEmail = address.email;
        this.order.shipToContactName = address.contactName;
        this.order.shipToAddress1 = address.address1;
        this.order.shipToAddress2 = address.address2;
        this.order.shipToCity = address.city;
        this.order.shipToState = address.state;
        this.order.shipToZip = address.zip;
        this.order.shipToCountry = address.country;
        this.order.shipToPhone = address.phone1;
        this.order.shippingNote = address.notes;

        this.setSelectedShipCountry();
    };

    editDealer() {
        const modalRef = this.modalService.show(DealerDetailComponent, {
            class: 'modal-lg',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                key: this.order.dealerId,
                showAsDialog: true,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            this.selectedAddress = null;
            await this.getData();
            if (!!this.order.dealer.shipSameAsBilling || !this.order.dealer.shipAddresses || this.order.dealer.shipAddresses.length === 0) {
                this.copyBilling();
            }
            modalRef.hide();
        });
    }

    copyBilling(){
        this.orderService.copyBilling(this.order);
    }

    async save() {
        this.result.next({ success: true, value: this.order });
        this.modalRef.hide();
    }

    cancel(): void {
        this.result.next({ success: false });
        this.modalRef.hide();
    }
}
